module.exports = __webpack_public_path__ + "img/shakhtar-donetsk-logo-icon.4306d403.png";